/* eslint-disable import/prefer-default-export */
import { css } from 'styled-components';

export const extendContentContainer = css`
  padding: 0px;
`;
